import { useTracking } from '~/composables/custom/useTracking';

export default defineNuxtRouteMiddleware((to) => {
  // we need to check if we are inside product because product is doing the same logic with different order
  if (import.meta.server || to.name === 'product') {
    return;
  }

  const { trackPage } = useTracking();

  trackPage();
});
